module.exports = __webpack_public_path__ + "assets/PasswordNotVisibleIcon.43feab85.svg";